module.exports = __webpack_public_path__ + "static/img/32-100.f3e35b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-slider/32-100.jpg
// module id = 7NzE
// module chunks = 2